import { background, button, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { TabContext, TabList } from "@mui/lab";
import { Box, Tab as MuiTab, styled } from "@mui/material";
import { FCC } from "@/types/common";
export type TLedgerTabsProps = {
    value: string | number;
    selected: string | number;
    options: {
        label: string;
        value: string | number;
    }[];
    disabled?: boolean;
    onChange?: (event: React.SyntheticEvent, value: string | number) => void;
};
export const LedgerTabs: FCC<TLedgerTabsProps> = ({ value, selected, options, disabled, onChange, children }) => {
    return (<Wrapper>
      <TabContext value={value}>
        <TabList onChange={onChange} variant="fullWidth">
          {options.map((opt) => (<StyledTab key={opt.value} label={opt.label} value={opt.value} disabled={disabled && selected !== opt.value} sx={{ backgroundColor: selected === opt.value ? `${button.primary} !important` : `${divider.high} !important` }}/>))}
        </TabList>
        {children}
      </TabContext>
    </Wrapper>);
};
const Wrapper = styled(Box) `
  background-color: ${background.white};
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;

  & .MuiTabPanel-root,
  & > .MuiTabContext-root {
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  & .MuiTabs-indicator {
    display: none;
  }
  & .MuiTabs-flexContainer {
    gap: 16px;
    border-bottom: 4px solid ${button.primary};

    & .MuiButtonBase-root {
      text-transform: none;
      font-weight: bold;
      font-size: 16px;
      min-height: 56px;
      height: 56px;
      color: ${text.white};
      background-color: ${divider.high};
      border-top-left-radius: ${rounded.sm};
      border-top-right-radius: ${rounded.sm};
    }
    & .Mui-selected {
      background-color: ${button.primary};
    }
  }
`;
const StyledTab = styled(MuiTab) ``;
